import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: "http://localhost:8080?"
});

//For everything else
export const axiosInstance2 = axios.create({
    baseURL: process.env["REACT_APP_AXIOS_QMS_COMP_SERVER_BASE_URL"]
});

//For filetrace and side bar
export const axiosInstanceQMS = axios.create({
  baseURL: process.env["REACT_APP_AXIOS_SERVER_BASE_URL"]
});

export const setAuthToken = token => {
  if (token) {
    axiosInstance2.defaults.headers.common["Authorization"] = "Bearer " + token;
    axiosInstanceQMS.defaults.headers.common["Authorization"] = "Bearer " + token;
  } else {
    delete axiosInstance2.defaults.headers.common["Authorization"];
    delete axiosInstanceQMS.defaults.headers.common["Authorization"];
  }

  axiosInstance2.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS';
  axiosInstance2.defaults.headers.common['Access-Control-Allow-Origin'] = process.env["REACT_APP_AXIOS_QMS_COMP_SERVER_BASE_URL"];
  axiosInstance2.defaults.headers.common['Access-Control-Allow-Headers'] = 'Authorization, Lang';
  axiosInstance2.defaults.headers.common['Strict-Transport-Security'] = 'Strict-Transport-Security: max-age=31536000; includeSubDomains';
  axiosInstance2.defaults.headers.common['X-Frame-Options'] = 'X-Frame-Options: SAMEORIGIN';
  axiosInstance2.defaults.headers.common['X-Content-Type-Options'] = 'X-Content-Type-Options: nosniff';
  

  axiosInstanceQMS.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS';
  axiosInstanceQMS.defaults.headers.common['Access-Control-Allow-Origin'] = process.env["REACT_APP_AXIOS_SERVER_BASE_URL"];
  axiosInstanceQMS.defaults.headers.common['Access-Control-Allow-Headers'] = 'Authorization, Lang';
  axiosInstanceQMS.defaults.headers.common['Strict-Transport-Security'] = 'Strict-Transport-Security: max-age=31536000; includeSubDomains';
  axiosInstanceQMS.defaults.headers.common['X-Frame-Options'] = 'X-Frame-Options: SAMEORIGIN';
  axiosInstanceQMS.defaults.headers.common['X-Content-Type-Options'] = 'X-Content-Type-Options: nosniff';

};
